import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";
import { Plus, Check, Building2 } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const abs = (u) => (!u || u.startsWith("http") ? u : `${BACKEND_URL}${u}`);

export function ApplicationReceivedDialog({ open, onClose, brandName, brandLogoUrl, creatorName, creatorAvatarUrl, creatorHandle }) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#0C0C10] border-white/10 text-white max-w-md p-0 overflow-hidden" data-testid="application-received-dialog">
        <div className="px-8 pt-12 pb-8 text-center">
          <div className="flex items-center justify-center gap-6">
            <div className="relative">
              <div className="h-24 w-24 rounded-full overflow-hidden bg-white/5 hairline ring-2 ring-nexus-pink/40">
                {creatorAvatarUrl ? <img src={abs(creatorAvatarUrl)} alt={creatorName} className="w-full h-full object-cover" /> : <div className="w-full h-full flex items-center justify-center font-display text-3xl text-zinc-400">{(creatorName || "?")[0]}</div>}
              </div>
              <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 whitespace-nowrap inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-white/10 border border-white/10 text-[11px] text-zinc-200" data-testid="application-received-creator">
                <Check className="h-3 w-3 text-emerald-300" /> {creatorHandle || creatorName}
              </div>
            </div>
            <div className="h-10 w-10 rounded-full border border-white/15 flex items-center justify-center text-nexus-purple"><Plus className="h-4 w-4" /></div>
            <div className="h-24 w-24 rounded-2xl overflow-hidden bg-white flex items-center justify-center hairline" data-testid="application-received-brand-logo">
              {brandLogoUrl ? <img src={abs(brandLogoUrl)} alt={brandName} className="w-full h-full object-contain p-2" /> : <Building2 className="h-9 w-9 text-zinc-500" />}
            </div>
          </div>
          <DialogTitle className="font-display font-bold text-2xl tracking-tight mt-10 text-center" data-testid="application-received-title">{brandName} received your application!</DialogTitle>
          <p className="text-sm text-zinc-400 mt-3 leading-relaxed">
            Brands usually make hiring decisions within <span className="text-white font-semibold">5–7 days</span>. You'll get a push the moment they respond — track it any time in <Link to="/collabs" className="text-white font-semibold underline underline-offset-2">My Work</Link>.
          </p>
        </div>
        <div className="px-8 pb-8">
          <button type="button" onClick={onClose} className="w-full h-12 rounded-full nexus-gradient text-white font-semibold hover:opacity-90" data-testid="application-received-close">Got it</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
